/* ecnue wishlist — 自社お気に入り機能クライアント */
(function () {
  if (window.__ecnueWlInit) return;
  window.__ecnueWlInit = true;
  var CFG = window.ECNUE_WISHLIST || {};
  if (!CFG.api) return;

  // ===== ゲストID =====
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  var cachedGid = null;
  function readCookieGid() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)ecnue_wl_gid=([0-9a-f-]{36})/i);
      return m ? m[1] : null;
    } catch (e) { return null; }
  }
  function guestId() {
    if (cachedGid) return cachedGid;
    var id = null;
    try { id = localStorage.getItem("ecnue_wl_gid"); } catch (e) {}
    if (!id) id = readCookieGid();
    if (!id) id = uuid();
    cachedGid = id;
    try { localStorage.setItem("ecnue_wl_gid", id); } catch (e) {}
    try {
      document.cookie = "ecnue_wl_gid=" + id + "; path=/; max-age=31536000; SameSite=Lax";
    } catch (e) {}
    return id;
  }

  function authParams() {
    // 会員情報＋ゲストIDを常に併送。サーバーは会員署名を優先し、
    // 署名が無効な場合はゲストとして処理（全滅を防ぐ）
    var params = { guest_id: guestId() };
    if (CFG.cid && CFG.ts && CFG.sig) {
      params.cid = CFG.cid;
      params.ts = CFG.ts;
      params.sig = CFG.sig;
    }
    return params;
  }

  // ===== 状態 =====
  var items = [];               // [{product_id, handle, ...}]
  var idSet = {};               // product_id -> true
  var loaded = false;
  var readyQueue = [];

  function rebuildSet() {
    idSet = {};
    items.forEach(function (it) { idSet[String(it.product_id)] = true; });
  }

  function saveCache() {
    try { localStorage.setItem("ecnue_wl_cache", JSON.stringify(items)); } catch (e) {}
  }

  function fireChanged() {
    saveCache();
    document.dispatchEvent(new CustomEvent("ecnue:wishlist:changed", { detail: { items: items.slice() } }));
  }

  function updateButtons() {
    var btns = document.querySelectorAll("[data-ecnue-wishlist]");
    Array.prototype.forEach.call(btns, function (btn) {
      var on = !!idSet[String(btn.dataset.productId)];
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  // ===== API =====
  function qs(params) {
    return Object.keys(params).map(function (k) {
      return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
    }).join("&");
  }

  function refresh() {
    return fetch(CFG.api + "?" + qs(authParams()))
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (data) {
        items = data.items || [];
        rebuildSet();
        loaded = true;
        updateButtons();
        fireChanged();
        readyQueue.splice(0).forEach(function (fn) {
          try { fn(items); } catch (e) {}
        });
        return items;
      })
      .catch(function () {
        loaded = true;
        readyQueue.splice(0).forEach(function (fn) {
          try { fn(items); } catch (e) {}
        });
        return items;
      });
  }

  // ===== トースト通知（Swymの「追加しました」バナー同等） =====
  var toastEl = null;
  var toastTimer = null;
  function toast(message, withLink) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "ecnue-wl-toast";
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = "<span>" + message + "</span>" +
      (withLink ? '<a href="/pages/wishlist">お気に入りを見る</a>' : "");
    requestAnimationFrame(function () { toastEl.classList.add("is-show"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove("is-show");
    }, 2600);
  }

  function toggle(data) {
    var pid = String(data.productId || data.product_id || "");
    if (!pid) return Promise.resolve(null);
    var wasOn = !!idSet[pid];
    toast(wasOn ? "お気に入りから削除しました" : "お気に入りに追加しました", !wasOn);
    // 楽観的更新
    if (wasOn) {
      items = items.filter(function (it) { return String(it.product_id) !== pid; });
    } else {
      items.unshift({
        product_id: Number(pid),
        handle: data.handle || null,
        variant_id: data.variantId ? Number(data.variantId) : null,
        price: data.price ? Number(data.price) : null,
        added_at: new Date().toISOString()
      });
    }
    rebuildSet();
    updateButtons();
    fireChanged();

    var body = Object.assign({
      action: "toggle",
      product_id: Number(pid),
      variant_id: data.variantId ? Number(data.variantId) : null,
      handle: data.handle || null,
      price: data.price ? Number(data.price) : null,
      source: data.source || null
    }, authParams());

    return fetch(CFG.api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error("wishlist api error");
      return r.json();
    }).catch(function () {
      // 失敗したらサーバー状態に戻す
      return refresh();
    });
  }

  // ===== ゲスト→会員マージ（ログイン時に一度・裏で実行） =====
  function maybeMerge() {
    if (!CFG.cid) return Promise.resolve(null);
    var gid = null;
    try { gid = localStorage.getItem("ecnue_wl_gid"); } catch (e) {}
    if (!gid) gid = readCookieGid();
    if (!gid) return Promise.resolve(null);
    var flag = "ecnue_wl_merged_" + CFG.cid;
    try {
      if (sessionStorage.getItem(flag)) return Promise.resolve(null);
    } catch (e) {}
    var body = Object.assign({ guest_id: gid }, authParams());
    return fetch(CFG.api + "/merge", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      try { sessionStorage.setItem(flag, "1"); } catch (e) {}
      return r.ok ? r.json() : null;
    }).catch(function () { return null; });
  }

  // ===== クリック委譲 =====
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-ecnue-wishlist]");
    if (!btn) return;
    e.preventDefault();
    toggle({
      productId: btn.dataset.productId,
      variantId: btn.dataset.variantId,
      handle: btn.dataset.handle,
      price: btn.dataset.price,
      source: btn.dataset.source
    });
  });

  // 明示的な追加（トーストなし・ブリッジ/インポート用）
  function addSilent(data) {
    var pid = String(data.productId || "");
    if (!pid) return Promise.resolve(null);
    if (!idSet[pid]) {
      items.unshift({
        product_id: Number(pid),
        handle: data.handle || null,
        variant_id: data.variantId ? Number(data.variantId) : null,
        price: data.price ? Number(data.price) : null,
        added_at: new Date().toISOString()
      });
      rebuildSet();
    }
    var body = Object.assign({
      action: "add",
      product_id: Number(pid),
      variant_id: data.variantId ? Number(data.variantId) : null,
      handle: data.handle || null,
      price: data.price ? Number(data.price) : null,
      source: data.source || "bridge"
    }, authParams());
    return fetch(CFG.api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).catch(function () { return null; });
  }

  // ===== 公開API =====
  window.EcnueWishlist = {
    has: function (pid) { return !!idSet[String(pid)]; },
    list: function () { return items.slice(); },
    refresh: refresh,
    toggle: toggle,
    add: addSilent,
    ready: function (fn) {
      if (loaded) {
        try { fn(items.slice()); } catch (e) {}
      } else {
        readyQueue.push(fn);
      }
    }
  };

  // 初期化：キャッシュで即時表示 → ネットワークで最新化（マージは裏で）
  try {
    var cached = JSON.parse(localStorage.getItem("ecnue_wl_cache") || "null");
    if (cached && cached.length) {
      items = cached;
      rebuildSet();
      updateButtons();
      document.dispatchEvent(new CustomEvent("ecnue:wishlist:changed", { detail: { items: items.slice() } }));
    }
  } catch (e) {}
  refresh();
  maybeMerge().then(function (result) {
    if (result && result.moved > 0) refresh();
  });
})();
